import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_SHIFT_CATEGORIES,
  SHIFT_CATEGORY_SUBMIT_FORM,
  SHIFT_CATEGORY_EDIT_SUBMIT_FORM,
  SHIFT_CATEGORY_DELETE,
  GET_SHIFTS,
} from "constants/shiftCategories.constants";
import axios from "axios";
import {
  getShiftCategoriesSuccess,
  shiftCategoryActionSuccess,
  getShiftsSuccess,
} from "actions/shiftCategories.action";
import { showErrors, stopLoader } from "actions/general.action";

// get shift categories
const fetchShiftCategoriesRequest = async (page) => {
  let link = "/api/v1/super_admin/shift_categories";
  if (page) {
    link = `/api/v1/super_admin/shift_categories?page=${page}`;
  }
  return axios.get(link);
};

function* fetchShiftCategories({ page }) {
  try {
    const result = yield call(fetchShiftCategoriesRequest, page);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getShiftCategoriesSuccess(result.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const createShiftCategoryRequest = async (shift_category_data) => {
  const { name, order, shift_type, description } = shift_category_data;
  const shiftCategoryObject = {
    name: name,
    order: order,
    shift_type_id: shift_type === "gp" ? 0 : 1,
    description: description,
    active_status: true,
  };
  return axios.post("/api/v1/super_admin/shift_categories", shiftCategoryObject);
};

// create shift Category
function* createShiftCategory({ shift_category_data }) {
  try {
    const result = yield call(createShiftCategoryRequest, shift_category_data);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      const resultShiftCategories = yield call(fetchShiftCategoriesRequest);
      if (resultShiftCategories.message) {
        yield put(showErrors(resultShiftCategories.message));
      } else {
        yield all([
          put(shiftCategoryActionSuccess(resultShiftCategories.data)),
          put(stopLoader("Shift Category Created")),
        ]);
      }
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const updateShiftCategoryRequest = async (shift_category_data) => {
  const { id, name, order, shift_type, description } = shift_category_data;
  const shiftCategoryObject = {
    name: name,
    order: order,
    shift_type_id: shift_type === "gp" ? 0 : 1,
    description: description,
  };
  return axios.put("/api/v1/super_admin/shift_categories/" + id, shiftCategoryObject);
};

// update shiftCategory
function* updateShiftCategory({ shift_category_data, page }) {
  try {
    const reuslt = yield call(updateShiftCategoryRequest, shift_category_data);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      const resultShiftCategories = yield call(fetchShiftCategoriesRequest, page);
      if (resultShiftCategories.message) {
        yield put(showErrors(resultShiftCategories.message));
      } else {
        yield all([
          put(shiftCategoryActionSuccess(resultShiftCategories.data)),
          put(stopLoader("Shift Category Updated")),
        ]);
      }
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const deleteShiftCategoryRequest = async (id) => {
  return axios({
    method: "delete",
    url: "/api/v1/super_admin/shift_categories/" + id,
    headers: {
      'Content-Type': 'text/plain'
    },
    data: "",
  });
};

// Delete Shift Category
function* deleteShiftCategory({ shift_category_id }) {
  try {
    const reuslt = yield call(deleteShiftCategoryRequest, shift_category_id);
    if (reuslt.message) {
      yield put(showErrors(reuslt.message));
    } else {
      const resultShiftCategories = yield call(fetchShiftCategoriesRequest);
      if (resultShiftCategories.message) {
        yield put(showErrors(resultShiftCategories.message));
      } else {
        yield all([
          put(shiftCategoryActionSuccess(resultShiftCategories.data)),
          put(stopLoader("Shift Category Updated")),
        ]);
      }
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

const getShiftsRequest = async () => {
  return axios.get('/api/v1/super_admin/shifts');
};

function* getShifts() {
  try {
    const result = yield call(getShiftsRequest);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getShiftsSuccess(result.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}

export function* forkFetchShiftCategories() {
  yield takeEvery(FETCH_SHIFT_CATEGORIES, fetchShiftCategories);
}

export function* forkCreateShiftCategory() {
  yield takeEvery(SHIFT_CATEGORY_SUBMIT_FORM, createShiftCategory);
}

export function* forkUpdateShiftCategory() {
  yield takeEvery(SHIFT_CATEGORY_EDIT_SUBMIT_FORM, updateShiftCategory);
}

export function* forkDeleteShiftCategory() {
  yield takeEvery(SHIFT_CATEGORY_DELETE, deleteShiftCategory);
}

export function* forkGetShifts() {
  yield takeEvery(GET_SHIFTS, getShifts);
}

export default function* rootSaga() {
  yield all([
    fork(forkFetchShiftCategories),
    fork(forkCreateShiftCategory),
    fork(forkUpdateShiftCategory),
    fork(forkDeleteShiftCategory),
    fork(forkGetShifts),
  ]);
}
